/* Instruments */
/* eslint-disable */
import { EcEnv, enableMulberry } from '@castlery/config';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { retailSlice } from '@castlery/modules-retails-domain';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  adminSlice,
  authSlice,
  customerSlice,
  saleListSlice,
  userSlice,
  wishlistSlice,
  zipcodeSlice,
} from '@castlery/modules-user-domain';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { orderHistorySlice, orderSlice, serviceSlice } from '@castlery/modules-order-domain';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  autoCompleteListSlice,
  productCompleteListSlice,
  productListSlice,
  productOptionSlice,
  productSlice,
  reviewsSlice,
  shopTheLookSlice,
  stripeSlice,
  warrantySlice,
} from '@castlery/modules-product-domain';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { couponSlice, promotionSlice } from '@castlery/modules-promotion-domain';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { checkoutSlice } from '@castlery/modules-checkout-domain';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { api, dyApi, searchApi, yotpoBaseApi } from '@castlery/shared-redux-services';
// eslint-disable-next-line
import { cmsSlice } from '@castlery/modules-cms-domain';

import { dySlice } from '@castlery/modules-dy-domain';

export const reducer = {
  [api.reducerPath]: api.reducer,
  [searchApi.reducerPath]: searchApi.reducer,
  [yotpoBaseApi.reducerPath]: searchApi.reducer,
  [dyApi.reducerPath]: dyApi.reducer,
  [productSlice.reducerPath]: productSlice.reducer,
  [productListSlice.reducerPath]: productListSlice.reducer,
  [stripeSlice.reducerPath]: stripeSlice.reducer,
  [authSlice.reducerPath]: authSlice.reducer,
  [zipcodeSlice.reducerPath]: zipcodeSlice.reducer,
  [orderSlice.reducerPath]: orderSlice.reducer,
  [productOptionSlice.reducerPath]: productOptionSlice.reducer,
  [serviceSlice.reducerPath]: serviceSlice.reducer,
  [checkoutSlice.reducerPath]: checkoutSlice.reducer,
  [saleListSlice.reducerPath]: saleListSlice.reducer,
  [autoCompleteListSlice.reducerPath]: autoCompleteListSlice.reducer,
  [productCompleteListSlice.reducerPath]: productCompleteListSlice.reducer,
  [cmsSlice.reducerPath]: cmsSlice.reducer,
  [dySlice.reducerPath]: dySlice.reducer,
  [customerSlice.reducerPath]: customerSlice.reducer,
  [promotionSlice.reducerPath]: promotionSlice.reducer,
  [couponSlice.reducerPath]: couponSlice.reducer,
  [orderHistorySlice.reducerPath]: orderHistorySlice.reducer,
  // [yotpoSlice.reducerPath]: yotpoSlice.reducer,
  ...(EcEnv.NEXT_PUBLIC_CHANNEL === 'POS' && {
    [retailSlice.reducerPath]: retailSlice.reducer,
    [adminSlice.reducerPath]: adminSlice.reducer,
    // [customerSlice.reducerPath]: customerSlice.reducer,
  }),
  ...(EcEnv.NEXT_PUBLIC_CHANNEL === 'WEB' && {
    [userSlice.reducerPath]: userSlice.reducer,
    [wishlistSlice.reducerPath]: wishlistSlice.reducer,
    [reviewsSlice.reducerPath]: reviewsSlice.reducer,
    [shopTheLookSlice.reducerPath]: shopTheLookSlice.reducer,
  }),
  // ...(enableMulberry && {
  [warrantySlice.reducerPath]: warrantySlice.reducer,
  // }),
};
